import React from 'react';
import {useTranslation} from 'react-i18next';
import {useLivenessStore} from 'components/LivenessDetection/store';
import Success from './icons/Success.json';
import Error from './icons/Error.json';
import LivenessFront from './icons/Liveness_Front.json';
import LivenessUp from './icons/Liveness_Up.json';
import LivenessBlink from './icons/Liveness_Blink.json';
import LivenessSide from './icons/Liveness_Side.json';
import {
  InstructionsContainer,
  InstructionText,
  LottieHelperIcon,
  LottieStatusIcon,
} from './styled';

type LivenessInstructionsProps = {
  className?: string;
};

export const LivenessInstructions: React.FC<LivenessInstructionsProps> = ({
  className,
}) => {
  const {t} = useTranslation('identity-verification');
  const currentStep = useLivenessStore(state => state.currentStep);
  const stepStatus = useLivenessStore(state => state.stepStatus);

  const getInstructionText = (): string => {
    switch (currentStep) {
      case 'LOOK_STRAIGHT':
        return t('liveness_detection.instructions.look_straight');
      case 'TURN_LEFT':
        return t('liveness_detection.instructions.turn_left');
      case 'TURN_RIGHT':
        return t('liveness_detection.instructions.turn_right');
      case 'TURN_UP':
        return t('liveness_detection.instructions.turn_up');
      case 'BLINK':
        return t('liveness_detection.instructions.blink');
      case 'COMPLETED':
        return t('liveness_detection.instructions.completed');
      default:
        return '';
    }
  };

  const getIcon = () => {
    if (stepStatus === 'error') {
      return <LottieStatusIcon animationData={Error} />;
    }
    if (stepStatus === 'success') {
      return <LottieStatusIcon loop={false} animationData={Success} />;
    }

    switch (currentStep) {
      case 'LOOK_STRAIGHT':
        return <LottieHelperIcon loop animationData={LivenessFront} />;
      case 'TURN_LEFT':
        return (
          <div style={{transform: 'scaleX(-1)'}}>
            <LottieHelperIcon loop animationData={LivenessSide} />
          </div>
        );
      case 'TURN_RIGHT':
        return <LottieHelperIcon loop animationData={LivenessSide} />;
      case 'TURN_UP':
        return <LottieHelperIcon loop animationData={LivenessUp} />;
      case 'BLINK':
        return <LottieHelperIcon loop animationData={LivenessBlink} />;
      case 'COMPLETED':
        return <LottieStatusIcon animationData={Success} />;
      default:
        return null;
    }
  };

  return (
    <InstructionsContainer className={className}>
      <InstructionText $status={stepStatus}>{getInstructionText()}</InstructionText>
      {getIcon()}
    </InstructionsContainer>
  );
};
